import { CookiebotEventMap } from '../models/cookiebot.models';

/**
 * Add a Cookiebot event listener to the window
 */
export function addCookiebotListener<K extends keyof CookiebotEventMap>(
	type: K,
	listener: (event: CookiebotEventMap[K]) => void
): void {
	window.addEventListener(<string>type, <EventListener>listener);
}

/**
 * Remove a Cookiebot event listener from the window object
 */
export function removeCookiebotListener<K extends keyof CookiebotEventMap>(
	type: K,
	listener: (event: CookiebotEventMap[K]) => void
): void {
	window.removeEventListener(<string>type, <EventListener>listener);
}
